export default __webpack_public_path__ + "static/media/New_Trips_Background.527edd00.svg";